// work data

export const Work = [
    {
        id:1,
        name:"MOQSH Annual Management Fest Website",
        description:"It is build on top of the React JS, with styledComponents for smooth scrolling animations.",
        tags:["react","scss","styledComponents"],
        
        demo:"https://snumoqsh.com/",
        github:"https://github.com/Moqsh-IT-Team/LayoutMoqsh"
    },
    {
        id:2,
        name:"Amazon Clone",
        description:"A clone of Amazon build using ReactJS. With add to cart and checkout functionality.",
        tags:["react","css","firebase"],
        
        demo:"https://clone-final-8ab42.web.app/",
        github:"https://github.com/goelesha/amazon-clone-final"
        
    },
    {
        id:3,
        name:"Facebook Clone",
        description:"A clone of Facebook build using ReactJS. With realtime posting feature.",
        tags:["react","api","css","firebase"],
        
        demo:"https://facebook-clone-b9a9c.web.app/",
        github:"https://github.com/goelesha/fb-clone"
    },
    {
        id:4,
        name:"Voice-Enabled Shopping Assistant",
        description:"A cool voice assistant which can order and add itemss to your cart just on voice commands",
        tags:["python","selenium","web-automation"],
        
        demo:"https://youtu.be/hc7T6M2_MD8",
        github:"https://github.com/goelesha/VoiShop--Voice-Enabled-Shopping-Assistant"
       
    },{
        id:5,
        name:"Todo App(React + Redux)",
        description:"A todo app build using Redux-toolkit",
        tags:["react","redux","framer-motion"],
        
        demo:"https://todo-app-8ba1d.web.app/",
        github:"https://github.com/goelesha/todo-app"
        
    },
    
  
] 